import { FulfillmentProviderBundle } from '../constants/features';
import { useIsSellerFeatureEnabled } from './use-is-seller-feature-enabled';

export const useIs3PLPlanEnabledForSeller = () => {
  return useIsSellerFeatureEnabled(FulfillmentProviderBundle);
};
